import { useSearchParams, Navigate } from 'react-router-dom';
import Loading from '@/components/general/Loading';
import PageLayout from '@/components/general/PageLayout';
import { useAuth } from '@/providers/SupabaseAuthProvider';
import useLogout from '@/hooks/useLogout';
import { Paths } from '@/types/routes';

interface ProtectedRouteProps {
  element: JSX.Element;
  nestedRoute?: boolean;
}

const ProtectedRoute = function ({
  element,
  nestedRoute = false,
}: ProtectedRouteProps): JSX.Element {
  const { isAuthenticated, isLoading } = useAuth();
  const logout = useLogout();

  const [searchParams] = useSearchParams();
  const hasError = !!searchParams.get('error');

  if (hasError) {
    logout();
    return <div />;
  }

  if (isLoading) {
    return <Loading fullPage />;
  }

  if (!isAuthenticated) {
    return <Navigate to={Paths.LOGIN} replace />;
  }

  if (nestedRoute) {
    return element;
  }

  return <PageLayout>{element}</PageLayout>;
};

export default ProtectedRoute;
